import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class BrowserSessionStorageService extends BrowserStorageService {
  constructor() {
    const platformId = inject(PLATFORM_ID);

    super(platformId, window.sessionStorage);
  }
}
